var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userLocation)?_c('div',[(_vm.locationDetected)?_c('google-marker',{attrs:{"position":_vm.userLocation,"clickable":false,"draggable":false,"icon":{
      url: _vm.circle,
      size: { width: 16, height: 16 },
      anchor: { x: 8, y: 8 }
    }}}):_vm._e(),_c('google-circle',{attrs:{"center":_vm.userLocation,"clickable":false,"draggable":false,"options":{
      fillColor: '#448AFF',
      fillOpacity: 0.25,
      strokeColor: '#448AFF',
      strokeOpacity: 0.5,
      strokeWeight: 1
    },"radius":_vm.locationInaccurate ? _vm.userLocation.acc : 0}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }